<template>
  <div class="recent-task-table-container">
    <star-condition-layout :onSearch="handleSearch" :onReset="reset" :loading="loading">
      <star-condition-cell label="任务状态">
        <a-select v-model="search.taskStatus" style="width: 100%">
          <a-select-option
            v-for="(item, index) in taskStatusOptions"
            :key="index"
            :value="item.value"
            >{{ item.label }}
          </a-select-option>
        </a-select>
      </star-condition-cell>

      <star-condition-cell label="站点类型">
        <a-select v-model="search.spiderClassType" style="width: 100%">
          <a-select-option
            v-for="item in spiderClassOptions"
            :key="item.spiderClassId"
            :value="item.type"
            >{{ item.spiderClassName }}
          </a-select-option>
        </a-select>
      </star-condition-cell>

      <star-condition-cell label="任务类型">
        <a-select v-model="search.taskType" style="width: 100%">
          <a-select-option v-for="(item, index) in taskTypeOptions" :key="index" :value="item.value"
            >{{ item.label }}
          </a-select-option>
        </a-select>
      </star-condition-cell>

      <star-condition-cell label="调度任务Id">
        <a-input v-model="search.taskId" style="width: 100%"> </a-input>
      </star-condition-cell>
    </star-condition-layout>

    <div class="table-container">
      <TableHeadIcons
        :onRefresh="queryScheduleRecordList"
        :size.sync="tableDensity"
        :columns="columns"
      >
      </TableHeadIcons>

      <a-table
        :size="tableDensity"
        :loading="loading"
        :pagination="pagination"
        @change="handleTableChange"
        rowKey="taskId"
        :columns="showColumns"
        :data-source="tableData"
      >
        <span slot="index" slot-scope="text, record, index">{{ index + 1 }}</span>

        <span slot="execTime" slot-scope="text, record">{{
          record.execTime | formatDuration
        }}</span>
        <span slot="waitTime" slot-scope="text, record">{{
          record.waitTime | formatDuration
        }}</span>
        <span slot="totalTime" slot-scope="text, record">{{
          record.totalTime | formatDuration
        }}</span>

        <span slot="taskType" slot-scope="text, record">
          <a-badge
            v-if="record.taskType == 0"
            color="green"
            :text="taskTypeFilter(record.taskType)"
          >
          </a-badge>
          <a-badge
            v-else-if="record.taskType == 1"
            color="orange"
            :text="taskTypeFilter(record.taskType)"
          ></a-badge>
          <a-badge v-else color="red" text="未知态"></a-badge>
        </span>
        <span slot="taskStatus" slot-scope="text, record">
          <a-badge
            v-if="record.taskStatus == 0"
            color="green"
            :text="taskStatusFilter(record.taskStatus)"
          >
          </a-badge>
          <a-badge
            v-else-if="record.taskStatus == 1"
            color="cyan"
            :text="taskStatusFilter(record.taskStatus)"
          >
          </a-badge>
          <a-badge
            v-else-if="record.taskStatus == 2"
            color="blue"
            :text="taskStatusFilter(record.taskStatus)"
          >
          </a-badge>
          <a-badge
            v-else-if="record.taskStatus == 3"
            color="purple"
            :text="taskStatusFilter(record.taskStatus)"
          >
          </a-badge>
          <a-badge
            v-else-if="record.taskStatus == 4"
            color="pink"
            :text="taskStatusFilter(record.taskStatus)"
          ></a-badge>
          <a-badge v-else color="red" text="未知态"></a-badge>
        </span>
        <span slot="action" slot-scope="text, record">
          <a-button v-if="record.taskStatus !== 2" @click="stopDispatch(record)" type="link">停止任务 </a-button>
          <a-divider v-if="record.taskStatus !== 2" type="vertical"></a-divider>
          <a-button @click="showLog(record)" type="link">日志 </a-button>
          <a-divider type="vertical"></a-divider>
          <router-link
            :to="{
              name: 'dispatch_task_info',
              query: {
                taskId: record.taskId,
                logUrl: record.logUrl
              }
            }"
          >
            <a-button type="link">详情 </a-button>
          </router-link>
        </span>
      </a-table>
    </div>

    <a-modal
      title="日志"
      :maskClosable="false"
      :width="logModalWidth"
      :visible="isShowLogModal"
      :footer="null"
      @cancel="isShowLogModal = false"
    >
      <TaskLog
        :logUrl="logUrl"
        :terminalHeight="`${logoModalTerminalHight}px`"
        v-if="isShowLogModal"
      />
    </a-modal>
  </div>
</template>

<script>
// TODO 提取一下,受不了啦
import { stopDispatchApi, queryScheduleRecordListApi } from '@/api/Dispatch/TaskManage'
import { querySpiderClassInfoApi } from '@/api/Site/Type'

import TaskLog from '../../Dispatch/TaskManageInfo/TaskLog'
import TableHeadIcons from '@/components/TableHeadIcons'
import tableSettingToStoreMixin from '@/mixin/tableSettingToStroe'

export default {
  components: { TaskLog, TableHeadIcons },
  mixins: [tableSettingToStoreMixin()],

  data() {
    return {
      search: {
        spiderClassType: undefined,
        taskType: undefined,
        taskStatus: undefined,
        taskId: undefined,
        spiderId: undefined
      },

      pagination: {
        current: 1,
        pageSize: 10,
        showTotal: (total) => `共 ${total} 条`,
        showSizeChanger: true,
        showQuickJumper: true,
        total: 0,
        size: 'default'
      },
      tableData: [],
      columns: [
        {
          width: 80,
          title: '序号',
          align: 'center',
          show: true,
          slots: { title: 'indexTitle' },
          scopedSlots: { customRender: 'index' }
        },
        {
          title: '站点名称',
          dataIndex: 'spiderName',
          show: true
        },
        {
          title: '站点类型',
          dataIndex: 'spiderClassName',
          show: true,
          scopedSlots: { customRender: 'spiderClassName' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: '任务类型',
          dataIndex: 'taskType',
          show: false,
          scopedSlots: { customRender: 'taskType' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: '任务状态',
          dataIndex: 'taskStatus',
          show: true,
          scopedSlots: { customRender: 'taskStatus' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: '开始时间',
          dataIndex: 'taskCreateTime',
          show: true,
          scopedSlots: { customRender: 'taskCreateTime' },
          align: 'center'
        },
        {
          title: '结束时间',
          dataIndex: 'taskEndTime',
          show: false,
          scopedSlots: { customRender: 'taskEndTime' },
          align: 'center'
        },
        {
          title: '运行时长',
          dataIndex: 'execTime',
          show: true,
          scopedSlots: { customRender: 'execTime' },
          align: 'center'
        },

        {
          title: '等待时长',
          dataIndex: 'waitTime',
          show: true,
          scopedSlots: { customRender: 'waitTime' },
          align: 'center'
        },
        {
          title: '总时长',
          dataIndex: 'totalTime',
          show: false,
          scopedSlots: { customRender: 'totalTime' },
          align: 'center'
        },
        {
          title: '结果数',
          dataIndex: 'resultNum',
          show: true,
          scopedSlots: { customRender: 'resultNum' },
          align: 'center'
        },
        {
          title: '操作',
          key: 'action',
          show: true,
          scopedSlots: { customRender: 'action' },
          width: 220,
          align: 'center'
        }
      ],
      taskStatusOptions: [
        {
          label: '启动',
          value: '0'
        },
        {
          label: '执行中',
          value: '1'
        },
        {
          label: '成功',
          value: '2'
        },
        {
          label: '失败',
          value: '3'
        },
        {
          label: '队列中',
          value: '4'
        }
      ],
      taskTypeOptions: [
        {
          label: '自动',
          value: '0'
        },
        {
          label: '手动',
          value: '1'
        }
      ],
      loading: false,
      tableDensity: 'middle',

      spiderClassOptions: [],

      isShowLogModal: false,
      logUrl: '',
      logModalWidth: window.innerWidth * 0.9,
      logoModalTerminalHight: window.innerHeight - 400
    }
  },
  computed: {
    showColumns() {
      return this.columns.filter((item) => item.show)
    }
  },
  created() {
    this.querySpiderClassInfo()
    this.queryScheduleRecordList()
  },
  methods: {
    reset() {
      this.search.taskStatus = undefined
      this.search.spiderClassType = undefined
      this.search.taskType = undefined
      this.search.taskId = undefined
      this.search.spiderId = undefined
      this.handleSearch()
    },

    handleSearch() {
      this.pagination.current = 1
      this.queryScheduleRecordList()
    },

    async querySpiderClassInfo() {
      let res = await querySpiderClassInfoApi()
      let { code, msg, data } = res
      if (code == '200') {
        this.spiderClassOptions = data
      } else {
        this.$message.error(msg)
      }
    },

    taskTypeFilter(value) {
      let res = this.taskTypeOptions.filter((item) => item.value == value)
      if (res.length > 0) {
        return res[0].label
      } else {
        return '未知'
      }
    },
    taskStatusFilter(value) {
      let res = this.taskStatusOptions.filter((item) => item.value == value)
      if (res.length > 0) {
        return res[0].label
      } else {
        return '未知'
      }
    },

    onTableDensityChange(density) {
      this.tableDensity = density
    },

    handleTableChange(pagination) {
      this.pagination = pagination
      this.queryScheduleRecordList()
    },

    async queryScheduleRecordList() {
      let query = {
        pn: this.pagination.current,
        pageSize: this.pagination.pageSize,
        ...this.search,
        spiderId: this.$route.query.spiderId
      }

      this.loading = true
      let res = await queryScheduleRecordListApi(query)
      this.loading = false
      let { code, msg, data, extra } = res
      if (code === 200) {
        this.tableData = data
        this.pagination.total = extra.page.pageCount || 0
      } else {
        this.$message.error(msg)
      }
    },

    showLog(record) {
      window.open(record.logUrl)
      // this.logUrl = record.logUrl
      // this.isShowLogModal = true
    },

    stopDispatch(record) {
      this.$confirm({
        title: '停止任务确认',
        content: '是否立刻停止任务?',
        autoFocusButton: 'ok',
        okText: '立刻停止',
        onOk: () => {
          stopDispatchApi({ taskId: record.taskId })
            .then(onHttpResponse)
            .then(() => {
              this.queryScheduleRecordList()
            })
            .catch(() => {})
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.recent-task-table-container {
  .table-container {
    background: white;
    padding: 0 16px;
    margin-top: 16px;
  }
}
</style>
